import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { history } from '../../';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { useStyles } from './styles';
import { tabRoutes } from '../../routes';
import { COMMUNITY_FORUM } from '../../utils/constants';
import Button from '../../components/Button';
import Link from '../../components/Link';

const ErrorPage = ({ destinationPage }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const ERROR_TITLE = t('pages.error.title');
	const ERROR_MESSAGE = t('pages.error.message');

	function generateMessage() {
		const message = ERROR_MESSAGE.split('^communityForum^');

		return message.length < 2
			? message
			: [
					message[0],
					<Link key={message[0]} href={COMMUNITY_FORUM.url}>
						{COMMUNITY_FORUM.label}
					</Link>,
					message[1]
			  ];
	}

	return (
		<Grid container direction="column" alignItems="center" className={classes.container}>
			<Grid item>
				<ErrorOutlineIcon className={classes.icon} />
			</Grid>

			<Grid item className={classes.title}>
				<Typography variant="h4">{ERROR_TITLE}</Typography>
			</Grid>

			<Grid item className={classes.message}>
				<Typography variant="body1">{generateMessage()}</Typography>
			</Grid>

			<Grid item>
				<Button
					color="primary"
					variant="contained"
					onClick={() => {
						history.replace(tabRoutes.find(route => route.path === destinationPage).path);
					}}>
					{t('pages.error.button')}
				</Button>
			</Grid>
		</Grid>
	);
};

ErrorPage.propTypes = {
	destinationPage: PropTypes.string.isRequired
};

export default ErrorPage;
